import { ChatIcon } from "@shared/components/ui/Icon";
import theme from "@shared/utils/themeColors";
import React, { useRef } from "react";
import { useChitChat } from "../context/ChitChatContext";
import {
  ConversationsProvider,
  useConversations,
} from "../context/ConversationsContext";
import ChitChatDropdown from "./ChitChatDropdown";

interface ChitChatIconProps {
  align?: "left" | "right";
}

const ChitChatIconContent: React.FC<ChitChatIconProps> = ({
  align = "right",
}) => {
  const { isDropdownOpen, toggleDropdown } = useChitChat();
  const { conversations } = useConversations();
  const trigger = useRef<HTMLButtonElement>(null);

  const totalUnread = conversations.reduce(
    (sum, conv) => sum + (conv.unreadCount || 0),
    0,
  );
  const hasUnread = totalUnread > 0;

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        data-chitchat-trigger
        className={`w-8 h-8 flex items-center justify-center hover:bg-gray-100 lg:hover:bg-gray-200 dark:hover:bg-gray-700/50 dark:lg:hover:bg-gray-800 rounded-full ${
          isDropdownOpen ? "bg-gray-200 dark:bg-gray-800" : ""
        } ${hasUnread ? "bg-amber-100 dark:bg-amber-900/50" : ""}`}
        aria-haspopup="true"
        onClick={toggleDropdown}
        aria-expanded={isDropdownOpen}
      >
        <span className="sr-only">Chit Chat</span>
        <ChatIcon
          className={
            hasUnread ? "text-amber-600 dark:text-amber-400" : theme.text.muted
          }
        />
        {hasUnread && (
          <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-amber-500 border-2 border-gray-100 dark:border-gray-900 rounded-full"></div>
        )}
      </button>
      <ChitChatDropdown align={align} />
    </div>
  );
};

const ChitChatIcon: React.FC<ChitChatIconProps> = (props) => {
  return (
    <ConversationsProvider>
      <ChitChatIconContent {...props} />
    </ConversationsProvider>
  );
};

export default ChitChatIcon;
